import { useCallback, useEffect } from 'react';
import { useApiGet, useApiLoading } from 'react-reqq-lite';
import * as actions from './actions';
import * as c from './constants';

export const useGetProfile = () => {
  const isLoading = useApiLoading(c.PROFILE, 'get');
  const data = useApiGet(c.PROFILE, {});

  useEffect(() => {
    actions.getProfile();
  }, []);
  return [data, isLoading];
};

export const useUploadOrgPhoto = () => {
  const isLoading = useApiLoading(c.PROFILE_UPLOAD_ORG_PHOTO, 'put');
  const upload = useCallback((payload) => {
    actions.uplpoadOrgPhoto(payload);
  }, []);
  return [upload, isLoading];
};
